var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Dropdown } from "../Dropdown";
import { getRainfall } from "../../../utils/api/rainfall/dataAccess";
export const RainfallDropdown = ({ value, onChange, label, }) => {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");
    useEffect(() => {
        const fetchCategories = () => __awaiter(void 0, void 0, void 0, function* () {
            const apiResponse = yield getRainfall();
            if (apiResponse.status === 200 && apiResponse.data) {
                const ddRainfall = apiResponse.data.map((category) => {
                    var _a;
                    return {
                        id: category.id,
                        name: category.name,
                        description: (_a = category.description) !== null && _a !== void 0 ? _a : "",
                        minimumRainfallMm: category.minimumRainfallMm,
                        maximumRainfallMm: category.maximumRainfallMm,
                    };
                });
                setCategories(ddRainfall);
            }
        });
        fetchCategories();
    }, []);
    //================================================================================================
    // FUNCTIONS
    //================================================================================================
    const handleOnChange = (value) => {
        var _a;
        setSelectedCategory((_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : "");
        //from categories we will get a min-max values, pass them back as a number array
        let minMaxValues = categories
            .map((category) => {
            if (category.id === value &&
                (category.minimumRainfallMm || category.minimumRainfallMm === 0) &&
                category.maximumRainfallMm) {
                return [category.minimumRainfallMm, category.maximumRainfallMm];
            }
            else {
                return [];
            }
        })
            .flat();
        onChange(value !== null && value !== void 0 ? value : '', minMaxValues);
    };
    return (React.createElement(Dropdown, { items: categories, displayName: "description", displayValue: "id", label: label !== null && label !== void 0 ? label : "Average Annual Rainfall (10 yr)", value: selectedCategory, onChange: handleOnChange, labelPosition: "top", disabled: false, minWidth: "150px", maxWidth: "220px", displayLabel: true }));
};
